import Layout from '@/layout/TheLayout.vue'
import { EXTRANET_GROUPS, JR_ACO_GROUP } from './utils'

export default [
  {
    path: '/',
    name: 'Purchase',
    meta: {
      title: 'Compras',
      showInSidebar: true,
      icon: 'mdi-cart',
      excludeGroup: [...EXTRANET_GROUPS,
        'AuxClara',
        'AuxCxP',
        'DesProveedores',
        'Proveedor',
        JR_ACO_GROUP
      ]
    },
    component: Layout,
    children: [
      {
        path: '/crear_requisicion/',
        name: 'Create Requisition',
        component: () => import('@/pages/Purchase/Register/index'),
        meta: {
          showInSidebar: true,
          title: 'Crear requisión',
          ifCan: {
            add: 'Quotation/requisitions'
          }
        }
      },
      {
        path: '/seguimiento_requisiciones/',
        name: 'Requisitions',
        component: () => import('@/pages/Purchase/Requisitions/index'),
        meta: {
          showInSidebar: true,
          title: 'Requisiones'
        }
      },
      {
        path: '/seguimiento_ordenes_de_compra/',
        name: 'Purchase Tracking',
        component: () => import('@/pages/Purchase/PurchaseOrders/index'),
        props: true,
        meta: {
          showInSidebar: true,
          title: 'Ordenes de compra'
        }
      },

      {
        path: '/editar_requisicion/:id',
        name: 'Edit Requisition',
        props: true,
        component: () => import('@/pages/Purchase/Register/index'),
        meta: {
          showInSidebar: false,
          title: 'Editar requisión',
          ifCan: {
            change: 'Quotation/requisitions'
          }
        }
      }
    ]
  }
]
